module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/water@2x_6e2d93.jpg";